import { useEffect, useState } from "react";
import AppConst from "../apis/appconst";
import axios from "axios";

function SmsSetup() {
    const [formData, setFormData] = useState({
        integration_contact: '',
        integration_url: '',
        integration_header: '',
        integration_body: '',
        integration_type: 'smssetup',
        integration_user: '',
        alertMsg: '',
        alertMsgTyp: '',
        isAlert: false,
      });

     

    const [ldata, setLdata] = useState(null);

      const handleChange = (e) => {
       
        const { name, value } = e.target;
        setFormData(prev => ({
          ...prev,
          [name]: value
        }));
      };

      const handleSubmit = async (e) => {
        e.preventDefault();
        // alert(formData.email+"");
        const fd = new FormData();
        fd.append('integration_contact', formData.integration_contact);
        fd.append('integration_url', formData.integration_url);
        fd.append('integration_header', formData.integration_header);
        fd.append('integration_body', formData.integration_body);
        fd.append('integration_type', formData.integration_type);
        fd.append('integration_user', ldata.user_id);
        
        try {
            const response = await axios.post(AppConst.BASE_URL+AppConst.upIntiNowUrl, fd, {
                headers: {
                'Content-Type': 'multipart/form-data',
                },
            });

            if(response.data.status){
                setFormData(prev => ({
                    ...prev,
                    isAlert: true,
                    alertMsg: response.data.success,
                    alertMsgTyp: response.data.type,
                  }));
                initData();
            }
            else{
                setFormData(prev => ({
                    ...prev,
                    isAlert: true,
                    alertMsg: response.data.success,
                    alertMsgTyp: response.data.type,
                  }));
            }
        } catch (error) {
            setFormData(prev => ({
                ...prev,
                isAlert: true,
                alertMsg: "Failed",
                alertMsgTyp: "danger",
              }));
        }
        
      };
    const initData = async() => {
        const storedData = sessionStorage.getItem("ldata");
        if (storedData) {
            const parsed = JSON.parse(storedData);
            setLdata(parsed);
            
            if(parsed!=null && parsed!=undefined){
                const fd = new FormData();
                fd.append('integration_user', 1);
                fd.append('integration_type', formData.integration_type);
                try {
                    const response = await axios.post(AppConst.BASE_URL+AppConst.getIntiByUserUrl, fd, {
                        headers: {
                        'Content-Type': 'multipart/form-data',
                        },
                    });
                    if(response.data.status){
                        
                        var user_dt = response.data.user_dt;
                        if(user_dt!=null && user_dt!=undefined){
                            setFormData(prev => ({
                                ...prev,
                                integration_contact: user_dt.integration_contact,
                                integration_url: user_dt.integration_url,
                                integration_header: user_dt.integration_header,
                                integration_body: user_dt.integration_body,
                                integration_type: user_dt.integration_type,
                                integration_user: user_dt.integration_user,
                              }));
                        }
                    }
                } catch (error) {
                   
                }
            }
        }
      };

    useEffect(() => {
        console.log('Component mounted');
    
        initData();
    
        return () => {
          console.log('Component unmounted');
        };
      }, []);
    return (
        <div class="page-content">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-xxl-12">
                        <div class="card">
                            <div class="card-body">
                                <h5>Sms Setup</h5>
                                <br />
                                <div class="live-preview">
                                    <form  onSubmit={handleSubmit}>
                                        <div class="row">

                                            
                                            <div class="col-md-6">
                                                <div >
                                                    <label for="customername-field" class="form-label">Api Link</label>
                                                    <input name="integration_url" onChange={handleChange} value={formData.integration_url} class="form-control" placeholder="Enter Api Link"
                                                        type="text" required/>
                                                </div>
                                            </div>

                                            <div class="col-md-6">
                                                <div >
                                                    <label for="customername-field" class="form-label">Body</label>
                                                    <input name="integration_body" onChange={handleChange} value={formData.integration_body} class="form-control" placeholder="Enter Body" type="text" required/>
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div >
                                                    <label for="customername-field" class="form-label">Header</label>
                                                    <input name="integration_header" onChange={handleChange} value={formData.integration_header} class="form-control" placeholder="Enter Header"
                                                        type="text" required/>
                                                </div>
                                            </div>
                                            {formData.isAlert ?
                                    <div class="col-lg-12">
                                        <br/>
                                     <div class="alert alert-success material-shadow" role="alert">
                                        {formData.alertMsg}
                                    </div>
                                    </div>
                                     : <></>}
                                            <div class="col-lg-12">
                                                <div class="text-end">
                                                    <button type="submit" class="btn btn-primary">Save</button>
                                                </div>
                                            </div>
                                        </div>

                                    </form>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default SmsSetup;
